
import { mapGetters } from 'vuex'
import generateHeader from '~/helpers/header'
import { parseCart } from '~/helpers/shopify/cart'
import { parseCheckout } from '~/helpers/shopify/checkout'
import pageCartWordingModel from '~/models/storyblok/cart-page'
import Cart from '~/components/cart/Cart'
import CarouselCart from '~/components/cart/CarouselCart.vue'
export default {
  name: 'CartPage',
  components: { Cart, CarouselCart },
  provide() {
    return {
      wording: this.wording,
    }
  },
  async asyncData({ app: { $storyblok, $sentryException, $gtm } }) {
    try {
      const { story } = await $storyblok.getStory(`/pages/checkout_page`)
      $gtm.push({ page: { type: 'cart' } })
      return { wording: { ...pageCartWordingModel, ...story.content } }
    } catch (e) {
      $sentryException(e, {
        source: 'storyblok',
        level: 'warning',
        extra: 'Call storyblok checkout_page failed',
      })
    }
  },
  head() {
    if (!this.wording.SEO) return
    this.wording.SEO.og_image = this.wording.SEO.og_image
      ? this.wording.SEO.og_image
      : this.$config.DEFAULT_OG_IMAGE
    return {
      ...generateHeader({
        ...this.wording.SEO,
        path: this.$route.path,
      }),
      script: [
        { src: '//cdn.searchspring.net/intellisuggest/is.min.js', body: true },
      ],
    }
  },
  computed: {
    ...mapGetters({
      vxCustomer: 'customer/getCustomer',
      vxCart: 'cart/getCart',
      vxCheckout: 'checkout/getCheckout',
    }),
    cart() {
      if (this.vxCustomer) {
        return this.vxCheckout && this.vxCheckout.id
          ? parseCheckout(this.vxCheckout)
          : null
      } else {
        return this.vxCart && this.vxCart.id ? parseCart(this.vxCart) : null
      }
    },
    type() {
      return this.vxCustomer ? 'checkout' : 'cart'
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.vxCart?.lines?.edges?.length > 0) {
        this.$googleAnalyticsEvents.GA4ViewCart(this.vxCart.lines.edges, 'cart')
        if (window.IntelliSuggest?.init)
          this.intelliSuggestForSearchSpring('cart')
      } else if (this.vxCheckout?.lineItems?.edges > 0) {
        this.$googleAnalyticsEvents.GA4ViewCart(
          this.vxCheckout.lineItems.edges,
          'checkout'
        )
        if (window.IntelliSuggest?.init)
          this.intelliSuggestForSearchSpring('checkout')
      }
    }, 300)
  },
  methods: {
    intelliSuggestForSearchSpring(type) {
      try {
        const customer = this.$store.getters['customer/getCustomer']
        const products = []
        const skus = []
        if (type === 'cart') {
          this.vxCart.lines.edges.forEach(({ node }) => {
            products.push({
              sku: node.merchandise.sku,
              qty: node.quantity.toString(),
              price: node.merchandise.price.amount.toString(),
            })
            skus.push(node.merchandise.sku)
          })
        } else if (type === 'checkout') {
          this.vxCheckout.lineItems.edges.forEach(({ node }) => {
            products.push({
              sku: node.variant.sku,
              qty: node.quantity.toString(),
              price: node.variant.price.amount.toString(),
            })
            skus.push(node.variant.sku)
          })
        }
        this.$searchspring.events.cartPage(customer, skus, products)
      } catch (e) {
        this.$sentryException(e, {
          source: 'checkout cart',
          level: 'warning',
          extra: 'intellisuggest error in cart',
        })
      }
    },
  },
}
